/* Spanish catalog mirroring locale-support-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'nav.support': 'Soporte',
  'navhelp.support': 'Consulta y haz seguimiento de los casos de soporte que has enviado.',
  'route.support': 'Soporte',
  'support.title': 'Soporte',
  'support.contact': 'Contactar con soporte',
  'support.close': 'Cerrar',
  'support.send': 'Enviar',
  'support.sending': 'Enviando…',
  'support.editor.toolbar': 'Formato del mensaje',
  'support.editor.bold': 'Negrita',
  'support.editor.italic': 'Cursiva',
  'support.editor.underline': 'Subrayado',
  'support.editor.bullets': 'Lista con viñetas',
  'support.editor.numbered': 'Lista numerada',
  'support.editor.list': 'Lista',
  'support.editor.link': 'Enlace',
  'support.editor.linkPrompt': 'Pega un enlace http:// o https://',
  'support.editor.image': 'Imagen',
  'support.editor.screenshot': 'Captura de pantalla',
  'support.editor.screenshotLabel': 'Adjuntar una captura de pantalla de la vista actual',
  'support.editor.capturing': 'Haciendo la captura de pantalla…',
  'support.editor.pendingImages': 'Imágenes listas para enviar',
  'support.editor.removeImage': 'Quitar imagen',
  'support.editor.openImage': 'Abrir imagen',
  'support.editor.optimizing': 'Optimizando imágenes…',
  'support.retry': 'Reintentar',
  'support.back': 'Volver a los casos de soporte',
  'support.category': 'Categoría',
  'support.category.feil': 'Error / algo no funciona',
  'support.category.fakturering': 'Facturación y pagos',
  'support.category.sporsmal': 'Pregunta general',
  'support.category.annet': 'Otro',
  'support.subject': 'Asunto',
  'support.subject.placeholder': 'Breve descripción del problema',
  'support.message': 'Mensaje',
  'support.message.placeholder': 'Describe lo que ocurre, preferiblemente con detalles',
  'support.sent.title': 'Caso de soporte enviado',
  'support.sent.text': 'Hemos recibido {id} y te responderemos lo antes posible.',
  'support.new.title': 'Nuevo caso de soporte',
  'support.new.action': 'Nuevo caso',
  'support.filter.label': 'Filtrar casos de soporte',
  'support.filter.all': 'Todos',
  'support.filter.open': 'Abiertos',
  'support.filter.closed': 'Cerrados',
  'support.table.ticket': 'Caso',
  'support.table.category': 'Categoría',
  'support.table.sent': 'Enviado',
  'support.table.lastReply': 'Última respuesta',
  'support.lastReply.you': 'Tú',
  'support.lastReply.support': 'Soporte',
  'support.table.status': 'Estado',
  'support.status.open': 'Abierto',
  'support.status.closed': 'Cerrado',
  'support.opened': 'Abierto el {date}',
  'support.closeTicket': 'Marcar como cerrado',
  'support.table.actions': 'Acciones',
  'support.delete.rowAction': 'Eliminar',
  'support.delete.rowLabel': 'Eliminar el caso {{id}}',
  'support.delete.action': 'Eliminar caso',
  'support.delete.title': '¿Eliminar este caso?',
  'support.delete.confirm': 'Eliminar',
  'support.delete.text': 'El caso se quitará de tu lista y sus mensajes dejarán de estar accesibles para ti.',
  'support.delete.done': 'El caso se ha eliminado.',
  'support.error.delete': 'No se pudo eliminar el caso. Inténtalo de nuevo.',
  'support.reopen.action': 'Reabrir',
  'support.reopen.title': '¿Reabrir el caso de soporte?',
  'support.reopen.confirm': 'Reabrir de todos modos',
  'support.reopen.text': 'Reabre el caso solo si se refiere al mismo problema. Si es un problema nuevo, crea un nuevo caso de soporte.',
  'support.you': 'Tú',
  'support.agent': 'Soporte',
  'support.reply.placeholder': 'Continúa la conversación: escribe un mensaje a soporte',
  'support.closed.note': 'Este caso está cerrado. Puedes ver su historial, pero no puedes enviar más mensajes.',
  'support.empty.title': 'Aún no hay casos de soporte',
  'support.empty.filterTitle': 'No hay casos con este filtro',
  'support.empty.text': 'Los casos que envíes mediante el botón de soporte aparecerán aquí.',
  'support.loading.list': 'Cargando casos de soporte…',
  'support.loading.thread': 'Cargando la conversación…',
  'support.error.required': 'Introduce un asunto y un mensaje.',
  'support.error.noBusiness': 'Selecciona una empresa antes de contactar con soporte.',
  'support.error.create': 'No se pudo enviar el caso de soporte. Inténtalo de nuevo.',
  'support.error.list': 'No se pudieron cargar los casos de soporte.',
  'support.error.thread': 'No se pudo cargar la conversación.',
  'support.error.reply': 'No se pudo enviar el mensaje. Inténtalo de nuevo.',
  'support.error.status': 'No se pudo actualizar el estado del caso.',
  'support.error.link': 'Introduce un enlace http:// o https:// válido.',
  'support.error.imageType': 'Usa imágenes JPEG, PNG, GIF o WebP.',
  'support.error.imageSourceSize': 'Cada imagen de origen debe pesar 20 MB o menos.',
  'support.error.imageSourceTotal': 'Las imágenes de origen pueden sumar como máximo 40 MB por selección.',
  'support.error.imageCount': 'Puedes adjuntar hasta cuatro imágenes.',
  'support.error.imageSize': 'Una imagen sigue pesando más de 5 MB después de la optimización.',
  'support.error.imageTotal': 'Las imágenes optimizadas pueden sumar como máximo 10 MB por mensaje.',
  'support.error.imageOptimize': 'No se pudo optimizar la imagen. Prueba con una imagen más pequeña.',
  'support.error.screenshot': 'No se pudo hacer la captura de pantalla. Inténtalo de nuevo o adjunta una imagen manualmente.',
  'support.error.imagesUnavailable': 'El envío de imágenes requiere el servicio de soporte actualizado. Recarga la página e inténtalo de nuevo.',
  'support.error.requestTimedOut': 'El servicio de soporte no respondió. Inténtalo de nuevo.',
  'support.page.tickets': 'Casos',
  'support.page.articles': 'Artículos',
  'support.articles.back': 'Volver a los artículos',
  'support.articles.search.label': 'Buscar artículos de ayuda',
  'support.articles.categories': 'Categorías',
  'support.articles.results': 'Artículos encontrados: {count}',
  'support.articles.empty.title': 'No se encontraron artículos',
  'support.articles.empty.text': 'Prueba con otro término de búsqueda o elige otra categoría.',
  'support.articles.clear': 'Borrar búsqueda y filtro',
  'support.pages.label': 'Elegir página de soporte',
  'support.articles.search.placeholder': 'Buscar artículos de ayuda',
  'support.articles.count.one': '{count} artículo',
  'support.articles.count.other': '{count} artículos',
  'support.articles.resultsTitle': 'Resultados de la búsqueda',
  'err.nativeValidation.backend-support.1': 'Respuesta de eliminación de soporte no válida.',
});
